let defaultRoomType = {
    title: '',
    order: 0,
};

export default defaultRoomType;

